import { t } from "@wr/i18n";
import type { TransportState } from "@wr/ui";

/**
 * The connection banner's five strings, in **one** place.
 *
 * Extracted from `AppShell` in S5-5, because the round is the one phase where the
 * banner is not the shell's to render: §4.6 makes it an absolutely-positioned
 * strip pinned under the wrapper, so the wrapper resolves the same copy the shell
 * would have. Two implementations of *"what does the reconnecting banner say"* is
 * exactly the class of drift S4 §16's one-string-per-fact rule exists to stop, and
 * it would be invisible — the two surfaces are never on screen together.
 */
export function bannerText(state: TransportState): string {
  switch (state) {
    case "reconnecting":
      return t("net.reconnecting");
    case "browser-offline":
      return t("net.noInternet");
    case "restored":
      return t("net.back");
    default:
      return t("net.offline");
  }
}
